// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__mGCmi","label":"styles_label__T3I07"};